import React from 'react';
import useResizeObserver from 'hooks/use-resize-observer';
import styles from './styles.scss';

export default function SafeguardSection() {
	const { width } = useResizeObserver();
	return (
		<section className={styles['ac-interaction']}>
			<div className={styles['ac-safeguard-container']}>
			{width >= 768 ?
				<div className={styles['ac-safeguard-list']}>
					<div className={styles['ac-safeguard-tutor']}>
						<div className={styles['ac-safeguard-item']}>
							<div className={styles['man']}></div>
						</div>
						<div className={styles['ac-safeguard-item2']}>
							<div className={styles['introduce']}>
								<h1>The Perfect Tutor</h1>
								<p>We match your child with the perfect tutor and allow you to change as and when you need.</p>
							</div>
						</div>
					</div>
					<div className={styles['ac-safeguard-schedule']}>
						<div className={styles['ac-safeguard-item']}>
							<div className={styles['introduce']}>
								<h1>To Fit Your Schedule</h1>
								<p>Flexible booking and calendars allow you to change lesson times as you need.</p>
							</div>
						</div>
						<div className={styles['ac-safeguard-item2']}>
							<div className={styles['schedule']}></div>
						</div>
					</div>
					<div className={styles['ac-safeguard-learning']}>
						<div className={styles['ac-safeguard-item']}>
							<div className={styles['man']}></div>
						</div>
						<div className={styles['ac-safeguard-item2']}>
							<div className={styles['introduce']}>
								<h1>All Online Learning</h1>
								<p>Continue Tutoring from the comfort of your home or wherever you need. Our functional lessons ensure your children have all the tools they need.</p>
							</div>
						</div>
					</div>
					<div className={styles['ac-safeguard-stay']}>
						<div className={styles['ac-safeguard-item']}>
							<div className={styles['introduce']}>
								<h1>Stay Updated</h1>
								<p>You will be updated regularly on your child’s progress and development.</p>
							</div>
						</div>
						<div className={styles['ac-safeguard-item2']}>
							<div className={styles['schedule']}></div>
						</div>
					</div>
					{/* <div className={styles['ac-safeguard-text']}>
						<div className={styles['introduce']}>
							<h1>The Perfect Tutor</h1>
							<p>We match your child with the perfect tutor and allow you to change as and when you need.</p>
						</div>
					</div>
					<div className={styles['ac-safeguard-info']}>
						<div className={styles['introduce']}>
							<h1>To Fit Your Schedule</h1>
							<p>Flexible booking and calendars allow you to change lesson times as you need.</p>
						</div>
					</div>
					<div className={styles['ac-safeguard-item']}>
						<img className={styles['schedule']} src="https://web-data.zmlearn.com/image/oCPUYdykp2mdCqCFm678Pp/schedule.png" alt="" />
					</div>
					<div className={styles['ac-safeguard-item']}>
						<img className={styles['learning']} src="https://web-data.zmlearn.com/image/ormbnpjj2KHd8b1qWJVmKE/learning.png" alt="" />
					</div>
					<div className={styles['ac-safeguard-text']}>
						<div className={styles['introduce']}>
							<h1>All Online Learning</h1>
							<p>Continue Tutoring from the comfort of your home or wherever you need. Our functional lessons ensure your children have all the tools they need.</p>
						</div>	
					</div>
					<div className={styles['ac-safeguard-info']}>
						<div className={styles['introduce']}>
							<h1>Stay Updated</h1>
							<p>You will be updated regularly on your child is progress and development.</p>
						</div>	
					</div>
					<div className={styles['ac-safeguard-item']}>
						<img className={styles['stay']} src="https://web-data.zmlearn.com/image/fsnGsZvztdK5pDE8SerPDF/stay.png" alt="" />
					</div> */}
				</div>
				:<div className={styles['ac-safeguard-list']}>
					<div className={styles['ac-safeguard-text']}>
						<div className={styles['introduce']}>
							<h1>The Perfect Tutor</h1>
							<p>We match your child with the perfect tutor and allow you to change as and when you need.</p>
						</div>
					</div>
					<div className={styles['ac-safeguard-item']}>
						<div className={styles['man']}></div>
					</div>
					<div className={styles['ac-safeguard-info']}>
						<div className={styles['introduce']}>
							<h1>To Fit Your Schedule</h1>
							<p>Flexible booking and calendars allow you to change lesson times as you need.</p>
						</div>
					</div>
					<div className={styles['ac-safeguard-item']}>
						<div className={styles['schedule']}></div>
					</div>
					<div className={styles['ac-safeguard-text']}>
						<div className={styles['introduce']}>
							<h1>All Online Learning</h1>
							<p>Continue Tutoring from the comfort of your home or wherever you need. Our functional lessons ensure your children have all the tools they need.</p>
						</div>	
					</div>
					<div className={styles['ac-safeguard-item']}>
						<div className={styles['learning']}></div>
					</div>
					<div className={styles['ac-safeguard-info']}>
						<div className={styles['introduce']}>
							<h1>Stay Updated</h1>
							<p>You will be updated regularly on your child is progress and development.</p>
						</div>	
					</div>
					<div className={styles['ac-safeguard-item']}>
						<div className={styles['stay']}></div>
					</div>
				</div>
				}
			</div>
		</section>
	);
}
